import React from 'react';
import { Icon } from 'antd';
import getAttachmentType from '../../../../helpers/getAttachmentType';
import { getAttachmentNameWithExtension } from '../../../../helpers/getAttachmentNameWithExtension';
import ImageIcon from './components/ImageIcon';
import PdfIcon from './components/PdfIcon';
import styles from './IconBlock.module.scss';

const iconTypes = {
  'file-word': 'file-word',
  'file-excel': 'file-excel',
  'file-text': 'file-text',
  file: 'file-zip',
  'file-unknown': 'file',
};

const IconBlock = ({ attachment, attachments, getAttachmentUrl }) => {
  const fileNameWithExtension = getAttachmentNameWithExtension(attachment);
  const attachType = getAttachmentType(fileNameWithExtension);

  if (attachType === 'picture') {
    return (
      <ImageIcon
        attachment={attachment}
        attachments={attachments}
        getAttachmentUrl={getAttachmentUrl}
      />
    );
  }

  if (attachType === 'file-pdf') {
    return (
      <PdfIcon
        attachment={attachment}
        getAttachmentUrl={getAttachmentUrl}
      />
    );
  }

  return (
    <Icon
      type={iconTypes[attachType] || 'file'}
      className={styles.icon}
    />
  );
};

export default IconBlock;
